export class TicketRequest {
    public Drawings: number;
    public SelectedNumbers: number[];
    public Stake: number;
    public BingoGameId: number;
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/shared/domain/ticket-request.ts